<template>
    <!--<TabPageWrap :is-allowed="isPageAllowed" ref="tabPageWrap">-->
        <!--<template v-slot:tab="{ tab }">-->
            <!--<SpiderPage v-if="tab.name==='spider_page'"></SpiderPage>-->
            <!--<AgentPage v-if="tab.name==='plat_agent_page'"></AgentPage>-->
        <!--</template>-->
    <!--</TabPageWrap>-->
    <NoPermissionInfo />
</template>

<script>

    import NoPermissionInfo from '@/components/noPermissionInfo';
    import TabPageWrap from './components/tabPageWrap';
    import SpiderPage from './page/spiderPage';
    import AgentPage from './page/agentPage';
    import HomeAPI from '@/api/home.js';


    export default {
        name: "SpiderModal",
        components: {
            NoPermissionInfo,
            TabPageWrap,
            SpiderPage,
            AgentPage,
        },
        data() {

            return {
                isPageAllowed: true,
            }
        },
        computed: {

        },
        watch: {

        },
        created() {
            this.getPageAllowAction();

        },
        mounted() {

        },
        methods: {
            initPage(){
                console.log('initPage');
            },
            getPageAllowAction() {
                let navId = this.$route.meta.pid;
                let navTabId = this.$route.meta.id;
                if (navId) {

                    HomeAPI.getPageAllowAction({
                        action_id: navId,
                    }).then(res => {
                        let resData = res.data || {};
                        let actionData = (resData.page_action || []).find(item => item.id == navTabId);
                        this.pageFunc = actionData.func || [];
                    }, (err) => {
                        console.log('getPageAllowAction error', err);

                        this.isPageAllowed = false;
                        this.pageFunc = [];
                    });
                }else{
                    this.isPageAllowed = false;
                }
            },
        },
        beforeDestroy() {

        }
    }
</script>

<style lang="scss" scoped>



</style>
